import { render, staticRenderFns } from "./xuqiuSqA.vue?vue&type=template&id=01beb120&scoped=true"
import script from "./xuqiuSqA.vue?vue&type=script&lang=js"
export * from "./xuqiuSqA.vue?vue&type=script&lang=js"
import style0 from "./xuqiuSqA.vue?vue&type=style&index=0&id=01beb120&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01beb120",
  null
  
)

export default component.exports